exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vue-xlsx-container{display:inline-block;margin:0;padding:0;box-sizing:border-box}.vue-xlsx-container .c-hide{margin:0;padding:0;box-sizing:border-box;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5ec52c63!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/xlsx-to-table.vue
// module id = 7
// module chunks = 0